import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { map } from "rxjs";
import { IMemberDetail, IShgDetail } from "src/app/interfaces/member.interface";
import { DisplayErrorService } from "src/app/services/display-error.service";
import { LocalService } from "src/app/services/storage/storage.service";
import { IAajeevikaMemberRedisPayload, MemberDetails, UserDetails } from "../../models/dashboard.model";
import { DashboardService } from "src/app/services/dashboard.service";
import { MemberService } from "src/app/services/member.service";
import { MappedPld, MappedSHGForCrpRes } from "src/app/interfaces/response.interface";
import { CacheService } from "src/app/services/cache.service";
import { filterOutInActiveMembers } from "src/app/utils/util";

@Component({
    templateUrl: './member-modal.component.html',
    selector: 'member-modal',
    styleUrls: ['./member-modal.component.scss'],
    standalone: false
})
export class MemberModalComponent implements OnInit {
    existingMemberOptions = ['Yes', 'No'];
    userDetails!: UserDetails;
    memberDetails!: MemberDetails;
    membersData: IMemberDetail[] = [];
    totalRecords: IMemberDetail[] = [];
    saveDetailFromLastQuarterCtrl = new FormControl('No');
    memberCtrl: FormControl<IMemberDetail | null>  = new FormControl(null);
    quarter!: number;
    showMemberNameError = false;
    showAlreadyRegisteredError = false;
    shgData: IShgDetail[] = [];
    mappedSHGLoaded = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) private dialogData: { quarter: number; year: string },
        private dialogRef: MatDialogRef<MemberModalComponent>,
        private displayErrorService: DisplayErrorService,
        private localService: LocalService,
        private dashboardService: DashboardService,
        private memberService: MemberService,
        private cacheService: CacheService
    ) {
        const user = this.localService.get<UserDetails>('userDetails');
        if (user) {
            this.userDetails = user;
        }
        const member = this.localService.get<MemberDetails>('memberDetails');
        if (member) {
            this.memberDetails = member;
        }

        if (this.dialogData?.quarter) {
            this.quarter = this.dialogData.quarter;
        }
    }

    ngOnInit (): void {
      this.saveDetailFromLastQuarterCtrl.valueChanges.subscribe((value) => {
        if(value === 'Yes'){
          if(!this.mappedSHGLoaded)
          this.getAajeevikaMembersList();
        } else {
          this.memberCtrl.clearValidators();
          this.showMemberNameError = false;
        }
        this.memberCtrl.updateValueAndValidity();
      });
        this.memberCtrl.valueChanges.subscribe((name: any) => {
            if (name && typeof name === 'string') {
                this.membersData = this.totalRecords.filter((member: IMemberDetail) => member.memberName.toLocaleLowerCase().includes(name.toLocaleLowerCase()));
            } else {
                this.membersData = [...this.totalRecords];
            }
            filterOutInActiveMembers(this.membersData);
        });
    }

    selected () {
        this.showMemberNameError = false;
    }


    getMappedSHG () {
        this.memberService.getMappedSHGForCRP(this.userDetails.stateId,this.userDetails.blockId).subscribe((mappedPLdRes: MappedSHGForCrpRes) => {
          this.mappedSHGLoaded = true;
            if(mappedPLdRes.responseData && mappedPLdRes.responseData.length){
                const mappedSHGRes = mappedPLdRes.responseData.filter((record: MappedPld) => !record.memberId && !record.memberCode && !record.memberName && record.shgId && record.crpName && !record.deleted);
                this.shgData = mappedSHGRes.map((shg: MappedPld) => {
                    const shgInfo: IShgDetail = {
                        shgCode: shg.shgCode,
                        shgName: shg.shgName,
                        shgId: shg.shgId,
                        villageId: shg.villageId,
                        panchayatId: shg.panchayatId,
                        blockId: shg.blockId,
                        districtId: shg.districtId,
                        stateId: shg.stateId.toString()
                    };
                    return shgInfo;
                });

                this.shgData = Array.from(new Set(this.shgData.map(shg => shg.shgId))).map(id => this.shgData.find(shg => shg.shgId === id)!);
                this.getAajeevikaMembersList();
            } else {
                this.shgData = [];
                this.displayErrorService.setData({
                    error: {
                        message: 'pleaseContactBlockAdminForCrpShgMapping',
                        header: 'noMappingFound',
                        type: 'info'
                    }
                });
            }
        },(error) => {
            this.displayErrorService.setData(error);
        });
    }

    getAajeevikaMembersList () {
        const payload: any = {
            stateId: this.userDetails.stateId,
            districtId: this.userDetails.districtId,
            blockId: this.userDetails.blockId,
            fullData: false,
            year: this.dialogData.year,
            quarter: this.dialogData.quarter,
        };
        if(
             this.dialogData.quarter > 0 && this.dialogData.quarter < 4

        ){
          payload.filterQuarter = this.dialogData.quarter + 1
        }

        this.dashboardService.getAajeevikaMembersRedisV2(payload,false,true,'600',this.cacheService.API_KEYS.MEMBER_MODAL_LISTING)
            .pipe(map((response) => {
              this.mappedSHGLoaded = true;
              const responseData = response.body?.responseData || [];

                let dataofPreviousQuarter = responseData.filter(
                  (member: IMemberDetail) => {
                    const memberYear = Number(member.year); // e.g. 202425
                    const currentYear = Number(this.memberDetails.year); // e.g. 202425
                    const memberQuarter = member.quarter;
                    const currentQuarter = this.memberDetails.quarter;
                    return (
                      !member.deleted &&
                      (memberYear < currentYear ||
                        (memberYear === currentYear &&
                          memberQuarter < currentQuarter))
                      // member.currentOwner === this.userDetails.id &&
                      // member.lakhpatiDidi
                    );
                  }
                );
                  dataofPreviousQuarter =  dataofPreviousQuarter.reduce((acc: IMemberDetail[], current: IMemberDetail) => {
                        const x = acc.find(item => item.memberCode === current.memberCode);
                        if (!x) {
                            return acc.concat([current]);
                        } else if (x.quarter < current.quarter) {
                            return acc.map(item => item.memberCode === current.memberCode ? current : item);
                        } else {
                            return acc;
                        }
                    }, []);

                const dataofCurrentQuarter = responseData.filter((member: IMemberDetail) => {
                    return !member.deleted && member.quarter == this.memberDetails.quarter && member.year == this.memberDetails.year.toString();
                });

                dataofPreviousQuarter = dataofPreviousQuarter.sort((a:IMemberDetail , b: IMemberDetail) => {
                    return b.updatedDate - a.updatedDate;
                });

                return {dataofPreviousQuarter, dataofCurrentQuarter};
            }))
            .subscribe({
                next: ({dataofPreviousQuarter, dataofCurrentQuarter}) => {

                    //filtering existing data of previous quarter in current quarter
                    const existingMemberId = new Set(dataofCurrentQuarter.map((member: IMemberDetail) => member.memberId));
                    // const mappedShgCode = this.shgData.map((shg: IShgDetail) => shg.shgCode);

                    const filteredData = dataofPreviousQuarter.filter((member: IMemberDetail) => {
                        return !existingMemberId.has(member.memberId);
                    }).sort((a:any, b:any) => a.memberName.trim().localeCompare(b.memberName.trim()));

                    this.membersData = [...filteredData];
                    this.totalRecords = [...filteredData];
                    filterOutInActiveMembers(this.membersData);

                },
                error: (error) => {
                    this.displayErrorService.setData(error);
                }
            });
    }

    displayWithMember (event: IMemberDetail) {
        return event?.memberName;
    }

    close (exit?: boolean) {
        if(exit){
            this.dialogRef.close('EXIT');
            return;
        }
        if (this.saveDetailFromLastQuarterCtrl.value === 'Yes') {
            if (!this.memberCtrl.value || (typeof this.memberCtrl.value === 'string')) {
                this.showMemberNameError = true;
                return;
            }
        }
        this.dialogRef.close(this.memberCtrl.value || 'NEW');
    }
}
